import { render, staticRenderFns } from "./ServiceTypesWidget.vue?vue&type=template&id=aa8da06c&scoped=true"
import script from "./ServiceTypesWidget.vue?vue&type=script&lang=js"
export * from "./ServiceTypesWidget.vue?vue&type=script&lang=js"
import style0 from "./ServiceTypesWidget.vue?vue&type=style&index=0&id=aa8da06c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8da06c",
  null
  
)

export default component.exports